import { API_BASE_URL } from './baseUrl';
import { resolveErrorMessage } from '../utils/errorMessage';

export { API_BASE_URL };

export const request = async (url, options = {}) => {
  const defaultOptions = {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...(options.headers || {}),
    },
  };

  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      let detailText = '';
      let detailJson = null;
      try {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          detailJson = await response.json();
        } else if (!contentType.includes('text/html')) {
          detailText = await response.text();
        }
      } catch (_) {
        // ignore
      }
      const rawMessage = detailJson?.error_message
        || detailJson?.message
        || detailJson?.detail
        || detailText
        || '';
      const fallback = `请求失败（HTTP ${response.status}）`;
      const friendly = resolveErrorMessage(rawMessage, fallback);
      const err = new Error(friendly);
      err.status = response.status;
      err.detail = detailJson || detailText;
      err.url = url;
      throw err;
    }

    return await response.json();
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

export const postJson = (path, payload = {}) => request(`${API_BASE_URL}${path}`, {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const getWithQuery = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      value
        .filter((item) => item !== undefined && item !== null && String(item).trim() !== '')
        .forEach((item) => query.append(key, String(item)));
      return;
    }
    query.set(key, String(value));
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return request(`${API_BASE_URL}${path}${suffix}`);
};
